import classNames from 'classnames'
// eslint-disable-next-line import/no-internal-modules
import DropdownControl from '@insided/deprecated-preact-components/dropdown/DropdownControl'
// eslint-disable-next-line import/no-internal-modules
import { Item } from '@insided/deprecated-preact-components/dropdown/interfaces'
import Button from '../Button'
import { Timezone } from './types'
import { DropdownText } from './DropdownText'
import { FunctionalComponent } from 'preact'

export const timezoneToDropdownItem = (timezone: Timezone): Item => ({
  value: timezone.value,
  title: timezone.title,
  variant: 'primary'
})

export interface TimezoneSelectorProps {
  timezones: Timezone[]
  selected: Timezone | undefined
  onChange: (value: string | null) => void
  error?: boolean
  triggerClassName?: string
}

const TimezoneSelector: FunctionalComponent<TimezoneSelectorProps> = ({
  timezones,
  selected,
  onChange,
  error,
  triggerClassName
}) => {
  return (
    <div className='timezone-selector-wrapper'>
      <DropdownControl
        closeOnDropdownClick
        triggerClass={triggerClassName}
        align='adjust'
        trigger={
          <Button
            title={<DropdownText timezones={timezones} selected={selected} />}
            className={classNames('timezone-selector', 'qa-timezone-selector', {
              'validation-error': error,
              'no-timezone-selected-message': !selected
            })}
            icon='chevronDown'
          />
        }
        items={timezones.map((timezone) => ({
          ...timezoneToDropdownItem(timezone),
          onClick: (event) => onChange(event.target.getAttribute('value'))
        }))}
        hasSearch
      />
    </div>
  )
}
export * from './types'
export default TimezoneSelector
